import { isValidDate } from "./../../common/functions";

const validate = (values) => {
  const errors = {};
  if (!values.search) {
    errors.search = "Este campo no puede estar vacío";
  }

  if (values.advance_search && values.filters) {
    if (values.filters.date && !isValidDate(values.filters.date)) {
      errors.date = "Debe ser una fecha válida";
    }
  }

  return errors;
};

export default validate;
